import { __assign, __spreadArray } from "tslib";
import * as React from 'react';
import { create } from 'jss';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider, createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import jssRtl from 'jss-rtl';
import { BbThemeProvider } from '../BbThemeProvider';
import pxToRem from '../../internal/utilities/px-to-rem';
var generateClassName = createGenerateClassName();
function jssThemeProvider(Component) {
    console.warn('jssThemeProvider HOC has been deprecated and will be removed in a future release. Use JssThemeProvider instead.');
    var JssThemeProvider = function (props) {
        var theme = props.theme, jssInsertionPoint = props.jssInsertionPoint, isRtl = props.isRtl;
        var jss = create({
            plugins: __spreadArray(__spreadArray([], jssPreset().plugins, true), [pxToRem(), jssRtl()], false),
            insertionPoint: jssInsertionPoint || '',
        });
        return (React.createElement(StylesProvider, { jss: jss, generateClassName: generateClassName },
            React.createElement(BbThemeProvider, { theme: theme, isRtl: isRtl },
                React.createElement(CssBaseline, null),
                React.createElement(Component, __assign({}, props)))));
    };
    return JssThemeProvider;
}
export default jssThemeProvider;
//# sourceMappingURL=jssThemeProvider.js.map